<template>
  <div class="content">
    <v-row>
      <v-col cols="6">
        <h1 class="title">{{ $t("ticketBuyerTypes.title") }}</h1>
      </v-col>
      <v-col cols="6" align="end">
        <v-btn @click="handleCreateWebshopUserType()" color="primary">{{
          $t("ticketBuyerTypes.createButton")
        }}</v-btn>
      </v-col>
    </v-row>
    <div class="table">
      <table-list-users
        v-if="!isLoading"
        :headerList="tableHeaders"
        :userList="users"
        :seenAttrs="userSeenAttrs"
        :itemActionList="actions"
        userType="webshopUserType"
        :user="users"
        @userChanged="handleWebshopUserTypeEdit"
        @userDelete="handleWebshopUserDelete"
      />
      <v-card v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import TableListUsers from "@/components/global/tableListComponents/TableListUsers";
import { mapActions } from "vuex";
import CreateWebshopUserTypeModal from "@/components/global/modalComponents/CreateUserModal/CreateWebshopUserTypeModal.vue";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "TicketBuyerTypes",
  props: {},
  components: {
    TableListUsers,
  },
  data() {
    return {
      users: [],
      userSeenAttrs: ["title"],
      actions: [
        {
          icon: "mdi-edit",
          type: "edit",
        },
      ],
      isLoading: false,
    };
  },
  created() {
    this.emitter.on("userDeleteConfirm", this.handleWebshopUserDelete);
    this.getWebshopUserList();
  },
  methods: {
    ...mapActions({
      getWebshopUserType: "users/getWebshopUserType",
      createWebshopUserType: "users/createWebshopUserType",
      editTicketBuyerType: "users/editTicketBuyerType",
      deleteTicketBuyerType: "users/deleteTicketBuyerType",
    }),
    getWebshopUserList() {
      this.isLoading = true;
      this.getWebshopUserType()
        .then((response) => {
          this.users = response.list;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleCreateWebshopUserType() {
      this.emitter.emit("showComponentModalModal", {
        bind: {
          is: CreateWebshopUserTypeModal,
        },
        on: {
          createNewWebshopUserType: (createPayload) => {
            this.createWebshopUserType(createPayload)
              .then(() => {
                toast.success(this.$t("ticketBuyerTypes.succesCreateMessage"));
                this.getWebshopUserList();
              })
              .catch((err) => {
                console.log(err);
              });
          },
        },
      });
    },
    handleWebshopUserTypeEdit(userType) {
      this.editTicketBuyerType(userType)
        .then(() => {
          toast.success(this.$t("ticketBuyerTypes.succesModifyMessage"));
          this.getWebshopUserList();
        })
        .catch(() => {});
    },
    handleWebshopUserDelete(id) {
      this.deleteTicketBuyerType(id)
        .then(() => {
          toast.success(this.$t("ticketBuyerTypes.succesDeletMessage"));
          this.getWebshopUserList();
        })
        .catch(() => {});
    },
  },
  computed: {
    tableHeaders() {
      const headers = [
        {
          title: this.$t("ticketBuyerTypes.table.headers.types"),
          textAlign: "text-left",
          value: "title",
        },
        {
          title: this.$t("ticketBuyerTypes.table.headers.actions"),
          textAlign: "text-right",
          value: "actions",
        },
      ];
      return headers;
    },
  },
  beforeUnmount() {
    this.emitter.off("userDeleteConfirm", this.handleWebshopUserDelete);
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-top: 40px;
  .table {
    border-radius: 8px;
    margin-top: 32px;
    box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
  }
}
</style>
